/**
 * Single backdrop scrim for modals, menus, dropdowns, and dialog overlays.
 * Same gentle darken in every flow and theme (avoids dark-mode 0.8 vs menu 0.5 mismatch).
 */
export const MODAL_SCRIM_ALPHA = 0.72 as const

export const MODAL_SCRIM_RGBA = `rgba(0, 0, 0, ${MODAL_SCRIM_ALPHA})` as const
